//BookClubList.jsx 
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';

const BookClubList = () => {

  const location = useLocation();
  // console.log("Location in BookClubList ", location);
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();

  const [bookClubs, setBookClubs] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [userId, setUserId] = useState(authState.user._id);
  const [selectedBookClubId, setSelectedBookClubId] = useState(null);

  const fetchBookClubs = useCallback(() => {
    const config = {
      url: "/bookclub",
      method: "get",
      headers: { Authorization: authState.token },
    };

    fetchData(config, { showSuccessToast: false })
      .then(data => {
        if (data && Array.isArray(data)) {
          setBookClubs(data);
        } else {
          console.error("Invalid response format: BookClubs not found in response!");
        }
      })
      .catch(error => {
        console.error('Error fetching BookClubs:', error);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchBookClubs();
  }, [authState.isLoggedIn, fetchBookClubs]);

  const handleView = (bookClubId) => {
    setSelectedBookClubId(prevId => (prevId === bookClubId ? null : bookClubId));
  };

  const handleComments = (id) => {
    setSelectedRecordId(id);
  };

  const handleCommentSave = (id) => {
    setSelectedRecordId(id);
  };

  const formatDate = (date) => {
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleBooksClick = (bookClubId, bookClubTitle) => {
    navigate("/bookclub-books", { state: { bookClubId: bookClubId, bookClubTitle: bookClubTitle } })
  };

  const sortedBookClubs = [...bookClubs].sort((a, b) => b.bookClubName - a.bookClubName);

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>BookClub - List</h2>
      </div>
      <div className="my-2 mx-auto max-w-[700px] py-4">
        <div className="border border-gray-300 p-4 mt-4">
          <div className="flex justify-between items-center border-b border-b-gray-300 bg-purple-600">
            <div className='text-xl mt-1 mx-2  text-white w-7/10'>
              <p className='text-yellow-300' >There are {bookClubs.length} Active Digital Book Clubs on Think5Whys</p>
            </div>
          </div>
          {loading ? (
            <div className="spinner-container">
              <div className="spinner">
                <FontAwesomeIcon icon={faSpinner} spin />
              </div>
            </div>
          ) : (
            <div>
              {bookClubs.length === 0 ? (
                <div className='w-[600px] h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
                  <span>No record found!!</span>
                </div>
              ) : (
                sortedBookClubs.map((bookClub, index) => (
                  <div key={bookClub._id} className='bg-white my-1 p-4 text-gray-600 rounded-md shadow-md'>
                    <div className='flex items-center h-4'>
                      <span className='font-medium'>{index + 1}. {bookClub.bookClubTitle}</span>
                      <Tooltip text={"Club Details"} position={"top"}>
                        <span className='ml-auto mr-2 text-blue-500 cursor-pointer' onClick={() => handleView(bookClub._id)}>
                          <i className="fa-solid fa-eye"></i>
                        </span>
                      </Tooltip>
                      <Tooltip text={"Books"} position={"top"}>
                        <button
                          className="mr-4 text-purple-600 cursor-pointer w-4"
                          style={{ backgroundColor: 'transparent', border: 'none', margin: '0' }}
                          onClick={() => handleBooksClick(bookClub._id, bookClub.bookClubTitle)}
                        >
                          <i className="fa-solid fa-book"></i>
                        </button>
                      </Tooltip>
                    </div>
                    <div className='whitespace-pre  text-blue-700'>{bookClub.bookClubName}</div>
                    {selectedBookClubId === bookClub._id && (
                      <div className='bg-gray-200 text-black'>
                        <div>
                          <div>
                            <p><strong>Club Info</strong></p>
                            <p><strong>Name:</strong> {bookClub.bookClubTitle}</p>
                            <p><strong>Owner:</strong> {bookClub.ownerName}</p>
                            <p><strong>About:</strong> {bookClub.bookClubDesc}</p>
                            <p><strong>Message:</strong> {bookClub.bookClubMsg}</p>
                          </div>
                          <div>
                            <p className='text-blue-500'><strong>Club Rule:</strong></p>
                            <div>
                              {bookClub.bookClubRules.map((rule, ruleIndex) => (
                                <div key={ruleIndex} className={ruleIndex % 2 === 0 ? 'bg-blue-100' : ''}>
                                  <p><strong>{rule.ruleNo}.{' '}{rule.rule}</strong></p>
                                </div>
                              ))}
                            </div>
                          </div>
                          <div>
                            <p className='text-blue-500'><strong>Comments:</strong></p>
                            <div>
                              {bookClub.comments.map((comment, commentIndex) => (
                                <div key={commentIndex} className={commentIndex % 2 === 0 ? 'bg-blue-100' : ''}>
                                  <p><strong>{comment.commentBy}</strong></p>
                                  <p>{new Date(comment.date).toLocaleString()}</p>
                                  <p>{comment.comment}</p>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    </MainLayout>
  )
}

export default BookClubList;
